<mat-card
    class="daxa-card recent-orders-card mb-25 border-radius bg-white border-none d-block"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined">
                    search
                </i>
                <input type="text" class="input-search d-block w-100 border-none outline-0 rounded-pill"
                       placeholder="Chercher un contact..."
                       (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-title>
        <mat-card-subtitle>
            <button class="btn btn-primary btn-sm rounded-start-pill" (click)="openModal(content)">
                <span class="px-2">Nouveau</span>
            </button>
            <button class="btn btn-outline-primary btn-sm rounded-end-pill" [matMenuTriggerFor]="menu"
                    aria-haspopup="true" aria-expanded="false" id="dropdownMenuClickableInside">
                <i class="fa-solid fa-table px-3"></i>
            </button>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div class="recent-orders-table">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort>
                    <!-- Name Column -->
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nom</th>
                        <td mat-cell *matCellDef="let element"> {{ element.name }}</td>
                    </ng-container>

                    <ng-container matColumnDef="firstName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Prénom</th>
                        <td mat-cell *matCellDef="let element"> {{ element.firstName }}</td>
                    </ng-container>

                    <!-- Client Column -->
                    <ng-container matColumnDef="client">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Client</th>
                        <td mat-cell *matCellDef="let element"> {{ getClientName(element.clientId) }} </td>                 
                      </ng-container>

                    <!-- Address Column -->
                    <ng-container matColumnDef="address">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Addresse </th>
                        <td mat-cell *matCellDef="let element"> {{ element.address }}</td>
                    </ng-container>

                    <!-- Postal Code Column -->
                    <ng-container matColumnDef="postalCode">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Code Postal</th>
                        <td mat-cell *matCellDef="let element"> {{ element.postalCode }}</td>
                    </ng-container>

                    <!-- City Column -->
                    <ng-container matColumnDef="city">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Ville</th>
                        <td mat-cell *matCellDef="let element"> {{ element.city }}</td>
                    </ng-container>

                    <!-- Job Column -->
                    <ng-container matColumnDef="job">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Poste</th>
                        <td mat-cell *matCellDef="let element"> {{ element.job }}</td>
                    </ng-container>

                    <!-- Phone Column -->
                    <ng-container matColumnDef="phone">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Téléphone bureau </th>
                        <td mat-cell *matCellDef="let element"> {{ element.phone }}</td>
                    </ng-container>
                    <ng-container matColumnDef="mobilePhone">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Téléphone mobile  </th>
                        <td mat-cell *matCellDef="let element"> {{ element.mobilePhone }}</td>
                    </ng-container>
                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Actions</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-info text-center" style="justify-content: center !important;">
                                <button type="button" mat-button matTooltip="Visualiser" matTooltipPosition="above"
                                        (click)="openViewModel(element)">
                                    <i class="material-symbols-outlined">
                                        visibility
                                    </i>
                                </button>
                                <button type="button" mat-button matTooltip="Modifier" matTooltipPosition="above"
                                        (click)="openEditModal(element)">
                                    <i class="material-symbols-outlined text-primary">
                                        brush
                                    </i>
                                </button>
                                <button type="button" mat-button matTooltip="Supprimer" matTooltipPosition="above"
                                        (click)="confirmDelete(element)">
                                    <i class="material-symbols-outlined text-danger">
                                        delete
                                    </i>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="getdisplayedCol()"></tr>
                    <tr mat-row *matRowDef="let row; columns: getdisplayedCol();"></tr>

                    <div *ngIf="!loadingTable">
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="15">Aucun résultat trouvé pour "{{ input.value }}"</td>
                        </tr>
                    </div>

                </table>

                <div *ngIf="loadingTable">
                    <div *ngFor="let i of [].constructor(6)" class="skeleton-row">
                        <span class="skeleton-cell"></span>
                    </div>
                </div>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
    </mat-card-content>


</mat-card>


<!-- Add modal template for editing -->
<ng-template #editModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">
                    Modifier Client
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="editForm" (ngSubmit)="updatePoc()">
                <div class="row">
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Nom</mat-label>
                            <input matInput formControlName="name" placeholder="Ex. Dupont">
                            <mat-error *ngIf="editForm.get('name')?.hasError('required')">Le champ Nom est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Prénom</mat-label>
                            <input matInput formControlName="firstName" placeholder="Ex. John">
                            <mat-error *ngIf="editForm.get('firstName')?.hasError('required')">Le champ Prénom est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Client</mat-label>
                            <mat-select formControlName="clientId" placeholder="Sélectionner un client"  (selectionChange)="onClientSelected1($event.value)">
                                <mat-option *ngFor="let client of clientList" [value]="client.id">
                                    {{ client.socialReason }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="editForm.get('clientId')?.hasError('required')">Le champ Client est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Code postal</mat-label>
                            <input matInput formControlName="postalCode" placeholder="Ex. 12345">
                            <mat-error *ngIf="editForm.get('postalCode')?.hasError('required')">Le champ Code postal est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Ville</mat-label>
                            <input matInput formControlName="city" placeholder="Ex. New York">
                            <mat-error *ngIf="editForm.get('city')?.hasError('required')">Le champ Ville est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Poste</mat-label>
                            <input matInput formControlName="job" placeholder="Ex. Directeur des achats">
                            <mat-error *ngIf="editForm.get('job')?.hasError('required')">Le champ Poste est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Téléphone bureau  </mat-label>
                            <input matInput formControlName="phone" placeholder="Ex. +123-0123456789">
                            <mat-error *ngIf="editForm.get('phone')?.hasError('required')">La saisie du numéro de Téléphone bureau  est obligatoire</mat-error>
                            <mat-error *ngIf="editForm.get('phone')?.hasError('pattern')">Le numéro de téléphone bureau  doit être au format : +123-0123456789</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Téléphone mobile</mat-label>
                            <input matInput formControlName="mobilePhone" placeholder="Ex. +123-0123456789">
                            <mat-error *ngIf="editForm.get('mobilePhone')?.hasError('required')">La saisie du numéro de téléphone mobile est obligatoire</mat-error>
                            <mat-error *ngIf="editForm.get('mobilePhone')?.hasError('pattern')">Le numéro de téléphone mobile doit être au format : +123-0123456789</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>E-mail</mat-label>
                            <input type="email" matInput formControlName="email" placeholder="Ex. john.doe@example.com">
                            <mat-error *ngIf="editForm.get('email')?.hasError('required')">Le champ E-mail est obligatoire</mat-error>
                            <mat-error *ngIf="editForm.get('email')?.hasError('email')">Format d'email invalide</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Statut</mat-label>
                            <mat-select formControlName="flag">
                                <mat-option [value]="1">Actif</mat-option>
                                <mat-option [value]="0">Inactif</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12">
                        <mat-form-field class="mb-25">
                            <mat-label>Adresse</mat-label>
                            <textarea matInput formControlName="address" placeholder="Ex. 123 Main St"></textarea>
                            <mat-error *ngIf="editForm.get('address')?.hasError('required')">Le champ Adresse est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12">
                        <mat-form-field class="mb-25">
                            <mat-label>Notes</mat-label>
                            <textarea matInput formControlName="notes" placeholder="Ex. 123 Main St"></textarea>
                            <mat-error *ngIf="editForm.get('notes')?.hasError('required')">Le champ Adresse est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 text-right">
                        <button type="submit" class="btn btn-primary btn-sm">Sauvegarder</button>
                    </div>
                </div>
            </form>
           
        </mat-card-content>
    </mat-card>
</ng-template>


<ng-template #viewModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-content>
            <div class="row">
                <h5 class="px-3 fw-bold">Détails du contact :</h5>

                <!-- Name and First Name -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Nom :</div>
                    <p>{{ poc?.name }}</p>
                </div>

                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Prénom :</div>
                    <p>{{ poc?.firstName }}</p>
                </div>

                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Code Postal :</div>
                    <p>{{ poc?.postalCode }}</p>
                </div>

                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Ville :</div>
                    <p>{{ poc?.city }}</p>
                </div>

                <!-- Job and Contact Information -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Poste :</div>
                    <p>{{ poc?.job }}</p>
                </div>

                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Téléphone bureau  :</div>
                    <p>{{ poc?.phone }}</p>
                </div>

                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Téléphone Mobile :</div>
                    <p>{{ poc?.mobilePhone }}</p>
                </div>

                <!-- Email -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Email :</div>
                    <p>{{ poc?.email }}</p>
                </div>

                <!-- Flag and Client Information -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Statut :</div>
                    <p>{{ poc?.flag ? "Actif" : "Inactif" }}</p>
                </div>

                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Nom du Client :</div>
                    <p>{{ poc?.clientName }}</p>
                </div>

                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Nom de l'Utilisateur :</div>
                    <p>{{ poc?.userName }}</p>
                </div>

                <!-- Creation and Update Dates -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Créé le :</div>
                    <p>{{ poc?.creationDate | date }}</p>
                </div>

                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Modifié le :</div>
                    <p>{{ poc?.updateDate | date }}</p>
                </div>


                <!-- Address, Postal Code, and City -->
                <div class="col-sm-6 col-lg-8 border-top p-3">
                    <div class="fw-bold">Adresse :</div>
                    <p>{{ poc?.address }}</p>
                </div>

                <!-- Note -->
                <div class="col-sm-6 col-lg-8 border-top p-3">
                    <div class="fw-bold">Note :</div>
                    <p>{{ poc?.notes }}</p>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</ng-template>

<ng-template #content let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">
                    Nouveau
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="form" (ngSubmit)="savePoc()">
                <div class="row">
                    <!-- Form fields here -->
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Nom</mat-label>
                            <input matInput formControlName="name" placeholder="Ex. Dupont">
                            <mat-error *ngIf="form.get('name')?.hasError('required')">Le champ Nom est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Prénom</mat-label>
                            <input matInput formControlName="firstName" placeholder="Ex. John">
                            <mat-error *ngIf="form.get('firstName')?.hasError('required')">Le champ Prénom est obligatoire</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Client</mat-label>
                            <mat-select formControlName="clientId" placeholder="Sélectionner un client" (selectionChange)="onClientSelected($event.value)">
                                <mat-option *ngFor="let client of clientList" [value]="client.id">
                                    {{ client.socialReason }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('clientId')?.hasError('required')">Le champ Client est obligatoire</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Code Postal</mat-label>
                            <input matInput formControlName="postalCode" placeholder="Ex. 12345">
                            <mat-error *ngIf="form.get('postalCode')?.hasError('required')">Le champ Code Postal est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Ville</mat-label>
                            <input matInput formControlName="city" placeholder="Ex. Anytown">
                            <mat-error *ngIf="form.get('city')?.hasError('required')">Le champ Ville est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Poste</mat-label>
                            <input matInput formControlName="job" placeholder="Ex. Directeur des achats">
                            <mat-error *ngIf="form.get('job')?.hasError('required')">Le champ Poste est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Téléphone bureau </mat-label>
                            <input matInput formControlName="phone" placeholder="Ex. +123-0123456789">
                            <mat-error *ngIf="form.get('phone')?.hasError('required')">Le champ téléphone bureau  est obligatoire</mat-error>
                            <mat-error *ngIf="form.get('phone')?.hasError('pattern')">Le numéro de téléphone bureau  doit être au format +123-0123456789</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Téléphone mobile</mat-label>
                            <input matInput formControlName="mobilePhone" placeholder="Ex. +123-0123456789">
                            <mat-error *ngIf="form.get('mobilePhone')?.hasError('required')">Le champ Téléphone mobile est obligatoire</mat-error>
                            <mat-error *ngIf="form.get('mobilePhone')?.hasError('pattern')">Le numéro de téléphone doit être au format +123-0123456789</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>E-mail</mat-label>
                            <input type="email" matInput formControlName="email" placeholder="Ex. john.doe@example.com">
                            <mat-error *ngIf="form.get('email')?.hasError('required')">Le champ E-mail est obligatoire</mat-error>
                            <mat-error *ngIf="form.get('email')?.hasError('email')">Format d'e-mail invalide</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Statut</mat-label>
                            <mat-select formControlName="flag">
                                <mat-option [value]="1">Actif</mat-option>
                                <mat-option [value]="0">Inactif</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-12">
                        <mat-form-field class="mb-25">
                            <mat-label>Adresse</mat-label>
                            <textarea matInput formControlName="address" placeholder="Ex. 123 Main St"></textarea>
                            <mat-error *ngIf="form.get('address')?.hasError('required')">Le champ Adresse est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12">
                        <mat-form-field class="mb-25">
                            <mat-label>Notes</mat-label>
                            <textarea matInput formControlName="notes" placeholder="Ex. Notes"></textarea>
                            <mat-error *ngIf="form.get('notes')?.hasError('required')">Le champ Notes est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 text-right">
                        <button type="submit" class="btn btn-success btn-sm">Sauvegarder</button>
                    </div>
                </div>
            </form>
            
        </mat-card-content>
    </mat-card>
</ng-template>

<!-- Menu with Checkboxes -->
<mat-menu #menu="matMenu">
    <div class="scrollable-menu shadow-lg bg-body">
        <mat-checkbox [checked]="displayedColumns.length == columns.length" (change)=" handleIsAllColsSelected($event)"
                      (click)="$event.stopPropagation()">Tous
        </mat-checkbox>
        @for (col of columns; track $index) {
            <div>
                <mat-checkbox [value]="col"
                              [checked]="displayedColumns.includes(col) || displayedColumns.length == columns.length"
                              (click)="$event.stopPropagation(); onSelectionChange(col)">
                    {{ columnLabels[col] || col }}
                </mat-checkbox>
            </div>
        }
    </div>

</mat-menu>
